import posthog from "posthog-js";

import { config } from "./config";

export function initPostHog() {
  if (!config().postHogKey || !config().postHogHost) {
    return posthog;
  }
  const client = posthog.init(config().postHogKey, {
    api_host: config().postHogHost,
    capture_pageview: false,
  });
  client.register_for_session({ appVersion: config().version });

  return client;
}
